<template>
    <b-modal
        size="xl"
        v-model="modalShow"
        title="予約を変更する"
        hide-footer
        @hidden="close">
        <div class="t-admin">
            <div v-if="consultation !== null">
                <div class="d-flex justify-content-center">
                    <div class="detailWrapper">
                        <div class="title">{{ `${$locale.consultation_host}予約情報` }}</div>
                        <ul class="detailList">
                            <li>
                                <div>{{ `${$locale.consultation_host}日時:` }}</div>
                                <div class="d-flex">
                                    <div class="u-palt">
                                        <span>{{ helper.dateForHuman(consultation.start_time, timezone) }}</span><!--
                                     --><span :class="helper.dayForHumanCSS(consultation.start_time ,timezone)">
                                            {{ helper.dayForHuman(consultation.start_time, timezone, { bracket: true } ) }}
                                        </span>
                                    </div>
                                    <div class="u-palt ml-1">
                                        <span>{{ helper.timeForHuman(consultation.start_time, timezone) }}</span><!--
                                     --><span>〜</span><!--
                                     --><span>{{ helper.timeForHuman(consultation.end_time, timezone) }}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div>医師:</div>
                                <div>{{ consultation.doctor.full_name }}</div>
                            </li>
                            <li>
                                <div>{{ `${$locale.consultation_host}メニュー:` }}</div>
                                <div>{{ consultation.doctor_menu.title }}</div>
                            </li>
                            <li>
                                <div>料金:</div>
                                <div>{{ `${consultation.doctor_menu.consultation_price.toLocaleString()}円` }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="detailWrapper">
                        <div class="title">{{ `${$locale.patient}情報` }}</div>
                        <ul class="detailList detailListUser">
                            <li>
                                <div>名前:</div>
                                <div>
                                    <a href="#" @click="onClickUserNameLink(consultation.user, $event)">
                                        {{ consultation.user.full_name }}
                                    </a>
                                    <span class="text-muted small">{{ `(${consultation.user.full_name_kana})` }}</span>
                                </div>
                            </li>
                            <li>
                                <div>年齢:</div>
                                <div>{{ `${consultation.user.age}歳` }}</div>
                            </li>
                            <li>
                                <div>性別:</div>
                                <div>{{ `${consultation.user.sex ? '女性' : '男性'}` }}</div>
                            </li>
                            <li>
                                <div>タイムゾーン:</div>
                                <div>{{ `${helper.getOffsetFromUTC(consultation.user.timezone)} ${consultation.user.timezone}` }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="doctorsTableWrapper">
                <div
                    v-if="inProgress"
                    class="d-flex justify-content-center align-items-center m-5 p-5">
                    <b-spinner variant="yokumiru-admin"/>
                </div>
                <div v-else>
                    <div class="d-flex align-items-center mt-3 mb-2">
                        <div
                            class="input-group input-group-sm mr-3 d-flex align-items-center"
                            style="width: 200px;">
                            <div>{{ $locale.consultation_host }}科：</div>
                            <select
                                v-model="medicalCourseId"
                                @change="fetchDoctorMenus"
                                class="form-control">
                                <option
                                    v-for="medicalCourse in medicalCourses"
                                    :key="`medical_course_id_${medicalCourse.id}`"
                                    :value="medicalCourse.id">
                                    {{ medicalCourse.name }}
                                </option>
                            </select>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input
                                v-model="hasSchedule"
                                id="has_schedule"
                                class="custom-control-input"
                                type="checkbox"
                                @change="fetchDoctorMenus">
                            <label
                                class="custom-control-label"
                                for="has_schedule">
                                同じ時間帯に予約できるメニューのみ表示
                            </label>
                        </div>
                    </div>

                    <div class="adminMatchingDoctorSelectTableWrapper">
                        <b-table
                            striped
                            hover
                            responsive
                            :items="doctorMenus"
                            :fields="fields"
                            :sort-by.sync="$store.state.adminAlternativeDoctorMenus.sortBy"
                            :sort-desc.sync="$store.state.adminAlternativeDoctorMenus.sortDesc"
                            @sort-changed="fetchDoctorMenus"
                            class="table-bordered m-table">
                            <template v-slot:cell(consultation_minutes)="data">
                                <div>{{ `${data.item.consultation_minutes}分` }}</div>
                            </template>

                            <template v-slot:cell(consultation_price)="data">
                                <div>{{ `${data.item.consultation_price.toLocaleString()}円` }}</div>
                            </template>

                            <template v-slot:cell(doctor_menu_labels)="data">
                                <div
                                    v-if="data.item.doctor_menu_labels.length > 0"
                                    class="labelWrapper">
                                    <div class="labelWrapperInner">
                                        <div
                                            v-for="label in data.item.doctor_menu_labels"
                                            :key="`doctor_menu_label_${label.id}`"
                                            class="doctorMenuLabel">
                                            {{ label.name }}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:cell(full_name_kana)="data">
                                <a href="#" @click="onClickDoctorNameLink(data.item, $event)">
                                    {{ data.item.full_name }}
                                </a>
                                <div class="small">{{data.item.full_name_kana}}</div>
                            </template>

                            <template v-slot:cell(doctor_labels)="data">
                                <div
                                    v-if="data.item.doctor_labels.length > 0"
                                    class="labelWrapper">
                                    <div class="labelWrapperInner">
                                        <div
                                            v-for="label in data.item.doctor_labels"
                                            :key="`doctor_label_${label.id}`"
                                            class="doctorLabel">
                                            {{ label.name }}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:cell(has_schedule)="data">
                                <div class="hasScheduleWrapper d-flex align-items-center">
                                    <span v-if="!!data.item.has_schedule" class="text-success">空き有り</span>
                                    <span v-else class="text-danger">空き無し</span>
                                </div>
                            </template>

                            <template v-slot:cell(links)="data">
                                <b-button
                                    variant="yokumiru-orange"
                                    size="sm"
                                    @click="onClickChangeBtn(data.item, $event)">
                                    変更する
                                </b-button>
                            </template>
                        </b-table>

                        <div class="d-flex justify-content-between align-items-center">
                            <b-pagination
                                :total-rows="$store.state.adminAlternativeDoctorMenus.total"
                                :per-page="$store.state.adminAlternativeDoctorMenus.per_page"
                                v-model="$store.state.adminAlternativeDoctorMenus.current_page"
                                @change="fetchDoctorMenus">
                            </b-pagination>

                            <div class="d-flex flex-wrap align-items-center">
                                <div class="mb-3 mr-2">
                                    <span class="small">{{ dispPaginationDetail }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import YokumiruHelper from '../../../YokumiruHelper'
import constants from '../../../constants'
import {mapMutations} from "vuex";

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            consultation: null,
            doctorMenus: null,
            medicalCourses: [],
            medicalCourseId: null,
            hasSchedule: false,
            timezone: 'Asia/Tokyo',
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'title',
                    'label': 'メニュー名',
                    sortable: true,
                },
                {
                    'key': 'consultation_minutes',
                    'label': `${this.$locale.consultation_host}時間`,
                    sortable: false,
                },
                {
                    'key': 'consultation_price',
                    'label': `${this.$locale.consultation_host}料`,
                    sortable: false,
                },
                {
                    'key': 'doctor_menu_labels',
                    'label': 'メニューのラベル',
                    sortable: false,
                },
                {
                    'key': 'full_name_kana',
                    'label': '医師',
                    sortable: true,
                },
                {
                    'key': 'doctor_labels',
                    'label': '医師のラベル',
                    sortable: false,
                },
                {
                    'key': 'has_schedule',
                    'label': 'スケジュール',
                    sortable: false,
                },
                {
                    'key': 'links',
                    'label': '',
                    'class': 'text-center',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        /**
         * QueryString生成
         * @return {string}
         */
        buildQuery: function () {
            let query = '?'

            const state = this.$store.state.adminAlternativeDoctorMenus

            query += `page=${state.current_page}`
            query += `&sort=${state.sortBy}`
            query += `&desc=${state.sortDesc}`

            query += `&medical_course_id=${this.medicalCourseId}`

            if (this.hasSchedule) {
                query += '&has_schedule=1'
            }

            return query
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if ( this.$store.state.adminAlternativeDoctorMenus.total < 1 ) {
                return ''
            }
            return `全${this.$store.state.adminAlternativeDoctorMenus.total}件中 ${this.$store.state.adminAlternativeDoctorMenus.from}～${this.$store.state.adminAlternativeDoctorMenus.to}件表示`
        },
    },

    created: function () {
        bus.$on('open-modal-admin-alternative-doctor-menu-select', this.open)
        bus.$on('admin-doctor-menu-change-completed', this.close)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-alternative-doctor-menu-select')
        bus.$off('admin-doctor-menu-change-completed')
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminAlternativeDoctorMenus/setQuery',
            setQueries: 'adminAlternativeDoctorMenus/setQueries',
        }),

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminAlternativeDoctorMenus) {
                    this.setQueries(data.adminAlternativeDoctorMenus)
                }
            }
        },

        /**
         * モーダル表示
         * @param {object} consultation
         */
        open: async function (consultation) {
            this.consultation = { ...consultation }
            this.hasSchedule = false
            this.medicalCourseId = this.consultation.medical_course_id
            this.modalShow = true
            await this.fetchMedicalCourses()
            await this.fetchDoctorMenus()
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 相談科一覧
         */
        fetchMedicalCourses: async function () {
            if (this.inProgress || this.medicalCourses.length > 0) {
                return
            }
            this.inProgress = true

            const endpoint = constants.admin.medical_courses.endpoint.base
            await axios.get(endpoint).then(({data}) => this.medicalCourses = data)
            this.inProgress = false
        },

        /**
         * 代替メニュー一覧取得
         * @param {number|object} param
         */
        fetchDoctorMenus: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.consultations.endpoint.base

            await axios.get(`${endpoint}/${this.consultation.id}/alternative_doctor_menus${this.buildQuery}`)
                .then(({data}) => {
                    this.doctorMenus = data.data
                    this.setQuery({key: 'current_page', value: data.meta.current_page})
                    this.setQuery({key: 'per_page', value: data.meta.per_page})
                    this.setQuery({key: 'total', value: data.meta.total})
                    this.setQuery({key: 'from', value: data.meta.from})
                    this.setQuery({key: 'to', value: data.meta.to})
                })

            this.inProgress = false

            setTimeout(() => {
                document.querySelectorAll('div.labelWrapperInner').forEach((elem) => {
                    elem.style.width = elem.children.length * 120 + 'px'
                })
            }, 10)
        },

        /**
         * 変更するボタン押下時
         * @param {object} doctorMenu
         * @param {object} e
         */
        onClickChangeBtn: function (doctorMenu, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-alternative-doctor-menu-schedule', this.consultation, doctorMenu)
        },

        /**
         * 医師名リンク押下時
         * @param {object} doctorMenu
         * @param {object} e
         */
        onClickDoctorNameLink: function (doctorMenu, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-doctor-profile', doctorMenu.doctor_id)
        },

        /**
         * 会員名リンク押下時
         * @param {object} user
         * @param {object} e
         */
        onClickUserNameLink: function (user, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-user-profile', user.id)
        },
    },
}
</script>

<style scoped lang="scss">
.labelWrapper {
    overflow-x: scroll;
    width: 200px;
    padding: 8px 0;
    box-sizing: border-box;

    .labelWrapperInner {
        width: 500px;
    }
}

.doctorMenuLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 10px;
    color: #53A15B;
    font-size: 11px;
    border: 1px solid #DFEDDC;
    background-color: #F3F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.doctorLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 10px;
    color: #B49834;
    font-size: 11px;
    border: 1px solid #EDECDC;
    background-color: #F7F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.detailWrapper {
    flex-grow: 1;
    margin: 10px;
    padding: 15px 20px;
    background: #F3F3F3;
    border-radius: 8px;
    box-sizing: border-box;

    .title {
        font-size: 18px;
        font-weight: bold;
    }

    .detailList {
        padding-left: 0;
        margin: 7px 0 0;

        li {
            display: flex;
        }

        div {
            &:nth-child(1) {
                min-width: 100px;
            }
        }

        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .detailListUser {
        div {
            &:nth-child(1) {
                min-width: 100px;
            }
        }
    }
}

.hasScheduleWrapper {
    .hasScheduleIcon {
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 11px;
        color: #4f515a;
        background: #D9D9D9;
        border-radius: 50%;
        text-align: center;
        cursor: pointer;
    }
}
</style>

<style lang="scss">
.adminMatchingDoctorSelectTableWrapper {
    .b-table {
        min-width: 1100px;

        th, td {
            font-size: 0.75rem;
        }

        .tdMedicalCourseName {
            overflow-x: scroll;
            white-space: pre;
            width: 240px;
            padding: 5px 0;
            box-sizing: border-box;
            line-height: 0.8;
        }
    }
}
</style>
